import clsx from 'clsx'
import { RemoveMediaContainer, CustomCloseUploadBoxButton } from './removeMediaButton.styles'
import { RemoveMediaButtonProps } from './removeMediaButton.types'

const RemoveMediaButton = ({
  icon,
  className,
  showBackground = false,
  onRemove
}: RemoveMediaButtonProps) => {
  return (
    <RemoveMediaContainer
      $showBackground={showBackground}
      className={clsx('_mt-4 _mr-4', className)}
      data-test="remove-media-container"
    >
      <CustomCloseUploadBoxButton
        data-test="dropzone-box-close-button"
        className="_d-flex _cursor-pointer _border-0 _bg-transparent _outline-0"
        onClick={onRemove}
      >
        {icon}
      </CustomCloseUploadBoxButton>
    </RemoveMediaContainer>
  )
}

export default RemoveMediaButton
